// Edad a partir de 'AAAA-MM-DD' (null si la fecha no es válida)
export function edadDesde(fecha) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(fecha || ''));
  if (!m) return null;
  const [a, me, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const hoy = new Date();
  let edad = hoy.getFullYear() - a;
  if (hoy.getMonth() + 1 < me || (hoy.getMonth() + 1 === me && hoy.getDate() < d)) edad--;
  return edad >= 0 && edad <= 110 ? edad : null;
}

export const MENSAJE_REVISION = 'Tu cuenta fue bloqueada temporalmente porque la foto que subiste parece inapropiada. Quedó en revisión de un administrador y te vamos a avisar por correo.';

export const MENSAJE_MENOR = 'Cupido con Mate es solo para mayores de 18 años. No podemos activar tu cuenta.';
